<template>
  <list-table
    :url="url"
    title="گزارش سوییچ"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
export default {
  data() {
    return {
      url: "switchResult",
      fields: [
        { key: "title", label: "بانک" },
        { key: "count", label: "تعداد درخواست" },
        { key: "cost", label: "مجموع درخواست" },
      ],
      params: [{
          label:"تاریخ:",
          field: "date",
          type: "date-picker",
      }],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  methods: {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گزارش سوییچ" }]);
  },
};
</script>